export var SiteMessageType;
(function (SiteMessageType) {
    // 新增站內信格式
    SiteMessageType["CREATE_MANUAL_NOTIFICATION"] = "create_manual_notification";
    // 新增站內信模板格式
    SiteMessageType["CREATE_MANUAL_NOTIFICATION_TEMPLATE"] = "create_manual_notification_template";
    // 編輯站內信模板格式
    SiteMessageType["EDIT_MANUAL_NOTIFICATION_TEMPLATE"] = "edit_manual_notification_template";
})(SiteMessageType || (SiteMessageType = {}));
//# sourceMappingURL=SiteMessageType.js.map